import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BsKey, BsShieldCheck } from 'react-icons/bs';
import api from '../lib/api';
import '../styles/ai-theme.css';

export default function AdminBootstrapPage() {
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    setup_token: '',
  });
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    setErr(null);

    try {
      const res = await api.post('/accounts/bootstrap-superadmin/', form, {
        headers: {
          'X-Bypass-Auth': '1',
          'X-Setup-Token': form.setup_token,
        },
      });

      setMsg(res.data.message || 'Superadmin created successfully.');
    } catch (e2) {
      setErr(
        e2?.response?.data?.detail ||
          e2?.response?.data?.error ||
          (typeof e2?.response?.data === 'string'
            ? e2.response.data
            : JSON.stringify(e2?.response?.data || 'Failed.'))
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-scope">
      <div className="ai-bg">
        <div className="center-screen">
          <div className="glass-card p-0 card-fixed" style={{ maxWidth: 560, width: '100%' }}>
            <div className="glass-header d-flex align-items-center justify-content-between px-4 py-3">
              <div className="d-flex align-items-center gap-2">
                <BsShieldCheck className="fs-4 text-white" />
                <h4 className="h-title m-0">Bootstrap Superadmin</h4>
              </div>
              <span className="badge-soft d-inline-flex align-items-center gap-2">
                <BsKey />
                One-time Setup
              </span>
            </div>

            <div className="p-4">
              <p className="h-subtle mb-4">
                Use the server setup token to create the first superadmin account. This should
                only be done once in a secure environment.
              </p>

              {msg ? <div className="alert alert-success py-2">{String(msg)}</div> : null}
              {err ? <div className="alert alert-danger py-2">{String(err)}</div> : null}

              <form onSubmit={submit} className="d-grid gap-3">
                <div>
                  <label className="form-label text-white-50 small mb-1">Setup Token</label>
                  <input
                    className="form-control input-ai"
                    name="setup_token"
                    placeholder="Enter setup token"
                    value={form.setup_token}
                    onChange={onChange}
                  />
                </div>

                <div>
                  <label className="form-label text-white-50 small mb-1">Username</label>
                  <input
                    className="form-control input-ai"
                    name="username"
                    placeholder="Enter username"
                    value={form.username}
                    onChange={onChange}
                  />
                </div>

                <div>
                  <label className="form-label text-white-50 small mb-1">Email</label>
                  <input
                    className="form-control input-ai"
                    type="email"
                    name="email"
                    placeholder="Enter email"
                    value={form.email}
                    onChange={onChange}
                  />
                </div>

                <div>
                  <label className="form-label text-white-50 small mb-1">Password</label>
                  <input
                    className="form-control input-ai"
                    type="password"
                    name="password"
                    placeholder="Password (min 8 characters)"
                    value={form.password}
                    onChange={onChange}
                  />
                </div>

                <button className="btn-ai w-100" type="submit" disabled={loading}>
                  {loading ? 'Creating…' : 'Create Superadmin'}
                </button>

                <div className="d-grid gap-2">
                  <Link className="btn-ai-ghost w-100 text-center" to="/">
                    Back to Site
                  </Link>
                  <Link className="btn-ai-ghost w-100 text-center" to="/admin/login">
                    Go to Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}